export const useToast = defineStore('toast', () => {
  const showSnackbar = ref(false)
  const responseCode = ref(0)
  const responseMessage = ref('')

  return {
    showSnackbar,
    responseCode,
    responseMessage,
  }
})
